export const fileTypeToUserFacingName = (type: string) => {
    switch (type) {
        case 'application/pdf':
            return 'PDF'
        case 'image/jpeg':
            return 'JPG'
        case 'image/png':
            return 'PNG'
        case 'application/msword':
            return 'DOC'
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'DOCX'
        case 'application/vnd.ms-excel':
            return 'XLS'
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'XLSX'
        case 'text/plain':
            return 'TXT'
        case 'application/zip':
            return 'ZIP'
        case 'application/vnd.ms-powerpoint':
            return 'PPT'
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'PPTX'
        case 'application/rtf':
            return 'RTF'
        default:
            return type
    }
}

export const numBytesToUserFacingSize = (bytes: number) => {
    if (bytes < 1024) {
        return `${bytes} B`
    }
    else if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(1)} KB`
    }
    else if (bytes < 1024 * 1024 * 1024) {
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`
    }
    else {
        return `${(bytes / 1024 / 1024 / 1024).toFixed(1)} GB`
    }
}

export const imageFileTypes = [
    'image/apng',
    'image/avif',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/svg+xml',
    'image/webp',
]

export const getImageDimensionsFromUrl = (
    url: string
): Promise<{ width: number; height: number }> => {
    return new Promise((resolve, reject) => {
        const img = new Image()

        img.onload = () => {
            const width = img.width
            const height = img.height
            resolve({ width, height })
        }

        img.onerror = () => {
            reject(new Error('Failed to load image from URL'))
        }

        img.src = url
    })
}

export const resizeImageFile = (
    file: File,
    targetWidth: number,
    targetHeight: number
): Promise<File> => {
    return new Promise((resolve, reject) => {
        // Create an image to draw from the file
        const img = new Image()
        const url = URL.createObjectURL(file)

        img.onload = () => {
            // Clean up the object URL
            URL.revokeObjectURL(url)

            // Create a canvas with the target dimensions
            const canvas = document.createElement('canvas')
            canvas.width = targetWidth
            canvas.height = targetHeight

            // Draw the image to fit the dimensions (this is the simplest approach)
            const ctx = canvas.getContext('2d')
            if (!ctx) {
                reject(new Error('Could not get canvas context'))
                return
            }

            // Draw the image stretched to the target dimensions
            ctx.drawImage(img, 0, 0, targetWidth, targetHeight)

            // Convert the canvas to a Blob
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('Canvas to Blob conversion failed'))
                    return
                }

                // Create a new File from the Blob
                const resizedFile = new File([blob], file.name, {
                    type: file.type,
                    lastModified: file.lastModified,
                })

                resolve(resizedFile)
            }, file.type)
        }

        img.onerror = () => {
            URL.revokeObjectURL(url)
            reject(new Error('Error loading image'))
        }

        img.src = url
    })
}
